/**
 * Client-side companion to lib/api/csrf.ts.
 *
 * Reads the public `pw_csrf` cookie (set on login, NOT HttpOnly) and
 * returns it as an `X-CSRF-Token` header for mutating requests against
 * routes that call `requireCsrf()`. Returns an empty object on the
 * server or when the cookie is absent — callers can spread it
 * unconditionally.
 */
export function csrfHeader(): Record<string, string> {
  if (typeof document === "undefined") return {};
  const match = document.cookie.match(/(?:^|;\s*)pw_csrf=([^;]+)/);
  return match ? { "X-CSRF-Token": decodeURIComponent(match[1]) } : {};
}
